import React from "react";
import { ShieldCheck } from "lucide-react";

const ShopManageSummary = ({ adminCount, memberCount }) => {
  return (
    <section className="shop-manage-summary" aria-label="Team overview">
      <div className="shop-summary-copy">
        <span className="shop-summary-icon">
          <ShieldCheck size={21} />
        </span>
        <div>
          <h2>Your shop, in good hands</h2>
          <p>Review your team and invite new members.</p>
        </div>
      </div>
      <div className="shop-summary-stats">
        <div>
          <strong>{adminCount}</strong>
          <span>Admins</span>
        </div>
        <div>
          <strong>{memberCount}</strong>
          <span>Members</span>
        </div>
      </div>
    </section>
  );
};

export default ShopManageSummary;
